import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import { Assessment as AssessmentIcon } from "@mui/icons-material";

import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${ParkkiTheme.colors.darkGrey};
`;

const ViewerContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const InfoContainer = styled.div`
  color: ${ParkkiTheme.colors.white};
  text-align: center;
`;

const Icon = styled(AssessmentIcon)`
  font-size: 50px;
`;

type Props = {
  url: string;
};

function PDFViewer({ url }: Props): JSX.Element {
  const { formatMessage } = useIntl();
  const [componentRef, setComponentRef] = useState<{ current: any }>();

  useEffect(() => {
    function setIframe() {
      const element = componentRef?.current;

      if (!url || !element) {
        return null;
      }

      const iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.width = "100%";
      iframe.height = "100%";
      // @ts-ignore
      iframe.style = "border-width:0px;";

      element.innerHTML = "";
      element.appendChild(iframe);
    }

    setIframe();
  }, [url, componentRef]);

  return (
    <Container>
      {!url && (
        <InfoContainer>
          <Icon />
          <div>{formatMessage({ id: "components.pdfViewer.selectApdf" })}</div>
        </InfoContainer>
      )}
      {url && (
        <ViewerContainer
          ref={(ref: any) => {
            setComponentRef(ref);
          }}
          id="pdf-viewer"
        />
      )}
    </Container>
  );
}

export default PDFViewer;
